<div class="menu-toggle" (click)="open.set(!open())">
	<app-icon [name]="open() ? 'sluiten' : 'hamburger'" color="typography-4"></app-icon>
</div>
<app-top-level-menu vertical [class.is-open]="open()"></app-top-level-menu>
<div class="overlay" [class.is-open]="open()" (click)="close()"></div>
